import React, { useState } from 'react';
import { GlobalStyle } from './styles/GlobalStyles';
import { useGameState } from './hooks/useGameState';
import { translations } from './data/translations';
import MenuScreen from './components/Menu/MenuScreen';
import PlayerSetup from './components/GameSetup/PlayerSetup';
import GameActive from './components/GameActive/GameActive';
import GameHistory from './components/GameHistory/GameHistory';
import RulesScreen from './components/Rules/RulesScreen';

function App() {
  const [screen, setScreen] = useState('menu');
  const {
    currentGame,
    setCurrentGame,
    gameHistory,
    setGameHistory,
    addGameToHistory,
    clearCurrentGame,
    language,
    setLanguage
  } = useGameState();

  const handleStartNewGame = () => {
    setScreen('player-setup');
  };

  const handleGameStart = (playerNames) => {
    const players = playerNames.map((name, index) => ({
      id: index,
      name: name.trim(),
      score: 0
    }));

    const newGame = {
      id: Date.now().toString(),
      players,
      rounds: [],
      currentRound: 1,
      dateStarted: new Date(),
      isCompleted: false
    };

    setCurrentGame(newGame);
    setScreen('game-active');
  };

  const handleUpdateGame = (updatedGame) => {
    setCurrentGame(updatedGame);
  };

  const handleEndGame = () => {
    if (currentGame) {
      const completedGame = {
        ...currentGame,
        isCompleted: true,
        dateCompleted: new Date()
      };
      addGameToHistory(completedGame);
      clearCurrentGame();
    }
    setScreen('menu');
  };

  const handleDeleteGame = (gameId) => {
    setGameHistory(prev => prev.filter(game => game.id !== gameId));
  };

  const renderScreen = () => {
    switch (screen) {
      case 'menu':
        return (
          <MenuScreen
            currentGame={currentGame}
            language={language}
            setLanguage={setLanguage}
            onStartNewGame={handleStartNewGame}
            onContinueGame={() => setScreen('game-active')}
            onViewHistory={() => setScreen('history')}
            onViewRules={() => setScreen('rules')}
            translations={translations}
          />
        );
      case 'player-setup':
        return (
          <PlayerSetup
            onStartGame={handleGameStart}
            onBack={() => setScreen('menu')}
            translations={translations}
            language={language}
          />
        );
      case 'game-active':
        return currentGame ? (
          <GameActive
            game={currentGame}
            onUpdateGame={handleUpdateGame}
            onEndGame={handleEndGame}
            onBackToMenu={() => setScreen('menu')}
            translations={translations}
            language={language}
          />
        ) : (
          <MenuScreen
            currentGame={currentGame}
            language={language}
            setLanguage={setLanguage}
            onStartNewGame={handleStartNewGame}
            onContinueGame={() => setScreen('game-active')}
            onViewHistory={() => setScreen('history')}
            onViewRules={() => setScreen('rules')}
            translations={translations}
          />
        );
      case 'history':
        return (
          <GameHistory
            gameHistory={gameHistory}
            onBack={() => setScreen('menu')}
            onDeleteGame={handleDeleteGame}
            translations={translations}
            language={language}
          />
        );
      case 'rules':
        return (
          <RulesScreen
            onBack={() => setScreen('menu')}
            translations={translations}
            language={language}
          />
        );
      default:
        return (
          <MenuScreen
            currentGame={currentGame}
            language={language}
            setLanguage={setLanguage}
            onStartNewGame={handleStartNewGame}
            onContinueGame={() => setScreen('game-active')}
            onViewHistory={() => setScreen('history')}
            onViewRules={() => setScreen('rules')}
            translations={translations}
          />
        );
    }
  };

  return (
    <>
      <GlobalStyle />
      {renderScreen()}
    </>
  );
}

export default App;
